import { z } from 'zod';
import type { RuntimeFlag } from '../../generated/api/types.gen.js';
import { zSetOrganizationRuntimeFlagBody } from '../../generated/api/zod.gen.js';

/**
 * A `dangerous` flag may only be turned ON behind a typed confirmation. Turning one
 * OFF is always allowed: the safe direction must never be obstructed.
 */
export function requiresTypedConfirmation(flag: Pick<RuntimeFlag, 'risk' | 'value'>): boolean {
  return flag.risk === 'dangerous' && !flag.value;
}

/** The typed text must equal the flag key exactly (whitespace-trimmed). */
export function isConfirmationSatisfied(flag: Pick<RuntimeFlag, 'key'>, text: string): boolean {
  return text.trim() === flag.key;
}

/** Whether the switch is interactive at all. */
export function isToggleLocked(opts: { canWrite: boolean; pending: boolean }): boolean {
  return !opts.canWrite || opts.pending;
}

/** The confirmation form's schema: the generated flag body plus the typed key, which must match exactly. */
export function runtimeFlagConfirmSchema(flag: Pick<RuntimeFlag, 'key'>) {
  return zSetOrganizationRuntimeFlagBody.extend({
    confirmation: z.string().refine((text) => isConfirmationSatisfied(flag, text), `Type ${flag.key} exactly`),
  });
}
